import { render, staticRenderFns } from "./TdxBaseDropdown.vue?vue&type=template&id=449ebbc8&scoped=true&"
import script from "./TdxBaseDropdown.vue?vue&type=script&lang=js&"
export * from "./TdxBaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TdxBaseDropdown.vue?vue&type=style&index=0&id=449ebbc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ebbc8",
  null
  
)

export default component.exports